define([
	"dojo/_base/declare",
	"Quality/EditTestRun"
], function(declare,EditTestRun) {

	return declare(EditTestRun, {
		bColorContext: true
	});
});